var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoll(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 5.5H19.5C20.3284 5.5 21 6.17157 21 7V20C21 20.8284 20.3284 21.5 19.5 21.5H17.5C16.6716 21.5 16 20.8284 16 20V7C16 6.17157 16.6716 5.5 17.5 5.5ZM17.5 6.5C17.2239 6.5 17 6.72386 17 7V20C17 20.2761 17.2239 20.5 17.5 20.5H19.5C19.7761 20.5 20 20.2761 20 20V7C20 6.72386 19.7761 6.5 19.5 6.5H17.5ZM1.5 12.5H3.5C4.32843 12.5 5 13.1716 5 14V20C5 20.8284 4.32843 21.5 3.5 21.5H1.5C0.671573 21.5 0 20.8284 0 20V14C0 13.1716 0.671573 12.5 1.5 12.5ZM1.5 13.5C1.22386 13.5 1 13.7239 1 14V20C1 20.2761 1.22386 20.5 1.5 20.5H3.5C3.77614 20.5 4 20.2761 4 20V14C4 13.7239 3.77614 13.5 3.5 13.5H1.5ZM9.5 0.5H11.5C12.3284 0.5 13 1.17157 13 2V20C13 20.8284 12.3284 21.5 11.5 21.5H9.5C8.67157 21.5 8 20.8284 8 20V2C8 1.17157 8.67157 0.5 9.5 0.5ZM9.5 1.5C9.22386 1.5 9 1.72386 9 2V20C9 20.2761 9.22386 20.5 9.5 20.5H11.5C11.7761 20.5 12 20.2761 12 20V2C12 1.72386 11.7761 1.5 11.5 1.5H9.5Z",
    fill: "#718193"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoll);
export default __webpack_public_path__ + "static/media/poll.4a4599c12d751db459cf8bc31bbff554.svg";
export { ForwardRef as ReactComponent };